export class VersioneFuturaDTO {
    id: string;
    codice: string;
    nome: string;
    dataInizioValidita: string;
    dataFineValidita: string;
}